module.exports = __webpack_public_path__ + "static/saudi-b17aa51354e4033d690a22528b5dae70.png";